import { render, staticRenderFns } from "./PageSnippet.vue?vue&type=template&id=5a67fa92&scoped=true&"
import script from "./PageSnippet.vue?vue&type=script&lang=js&"
export * from "./PageSnippet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a67fa92",
  null
  
)

export default component.exports